// 甘孜市场
<template>
  <div class="subpage ganzi sell">
    <div class="flx-bs container">
      <div class="left">
        <div class="part">
          <div class="head flx-bc">
            <span class="title"><i class="icon icon-tb"></i>{{ $C('sell','outTitle','产值统计') }}</span>
            <div class="btns flx-lc">
              <span :class="outputActive===1?'active':''" @click="outputActive=1">{{ $C('sell','outTabMonth','月产值') }}</span>
              <span :class="outputActive===5?'active':''" @click="outputActive=5">{{ $C('sell','outTabYear','年产值') }}</span>
            </div>
          </div>
          <div class="chart" id="output"></div>
        </div>
        <div class="part" :style="$width===6144?{'margin-top':'60px'}:''">
          <div class="head flx-bc">
            <span class="title"><i class="icon icon-tb"></i>{{ $C('sell','sellTitle','销售额统计') }}</span>
            <div class="btns flx-lc">
              <span :class="sellActive===1?'active':''" @click="sellActive=1">{{ $C('sell','sellTabMonth','月销售额') }}</span>
              <span :class="sellActive===5?'active':''" @click="sellActive=5">{{ $C('sell','sellTabYear','年销售额') }}</span>
            </div>
          </div>
          <div class="chart" id="sell"></div>
        </div>
        <div class="part" :style="$width===6144?{'margin-top':'60px'}:''">
          <div class="head flx-bc">
            <span class="title"><i class="icon icon-tb"></i>{{ $C('sell','buyTitle','原料采购统计') }}</span>
            <div class="btns flx-lc">
              <span :class="buyActive===1?'active':''" @click="buyActive=1">{{ $C('sell','buyTabMonth','月原料采购') }}</span>
              <span :class="buyActive===5?'active':''" @click="buyActive=5">{{ $C('sell','buyTabYear','年原料采购') }}</span>
            </div>
          </div>
          <div class="chart" id="buy"></div>
        </div>
      </div>
      <div class="middle" :style="$width===6144?{'margin-top':'30px'}:''">
        <ul class="flx-cc btns" :style="$width===6144?{'margin-bottom':'70px'}:''">
          <li class="btn"><p>{{ $C('sell','expressLabelCount','件数') }}</p><p v-if="info.express">{{info.express.total}}</p></li>
          <li class="btn"><p>{{ $C('sell','expressLabelAccept','已签收') }}</p><p v-if="info.express">{{info.express.accept}}</p></li>
          <li class="btn"><p>{{ $C('sell','expressLabelPercent','签收比例') }}</p><p v-if="info.express">{{info.express.percent}}</p></li>
        </ul>
        <div class="map" id="sichuanMap" :style="$width===6144?{'height':'1700px'}:''"></div>
      </div>
      <div class="right">
        <div class="part">
          <table class="mytable">
            <tr :class="$width===6144?'lh60':''">
                <th>{{ $C('sell','thFhd','发货地') }}</th>
                <th>{{ $C('sell','thShd','收件地') }}</th>
                <th>{{ $C('sell','thJs','件数') }}</th>
                <th>{{ $C('sell','thYqs','已签收') }}</th>
                <th>{{ $C('sell','thKdqsbl','签收比例(%)') }}</th>
            </tr>
            <tr :class="$width===6144?'lh60':''" v-for="item in table" :key="item.shd">
                <td>{{item.fhd}}</td>
                <td>{{item.shd}}</td>
                <td>{{item.js}}</td>
                <td>{{item.yqs}}</td>
                <td>{{item.kdqsbl}}</td>
            </tr>
          </table>
        </div>
        <div class="part" :style="$width===6144?{'margin-top':'140px'}:''">
          <div class="head"><span class="title"><i class="icon icon-fenbu"></i>{{ $C('sell','areaTitle','销售地域统计') }}</span></div>
          <div class="area" id="area"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import echarts from 'echarts'
import 'echarts/map/js/china'
import 'echarts/map/js/world'
import 'echarts/map/js/province/sichuan'
// 地图翻译文件
import { nameMap } from '../../../public/assets/geo/nameMap'
export default {
  name: '',
  components: {  },
  data() {
    return {
      outputActive: 1, //产值1年5年
      info: {},
      distanceData: [],
      output: [],
      sellActive: 1,
      sell: [],
      buyActive: 1,
      buy: [],
      area: [],
      table: []
    };
  },
  mounted() {
  },
  watch: {
    '$route.path':{
      handler(path){
        if(path==='/sell'){
          //this.fetchData('/assets/ganzi.json')
          this.getData('ganzi')
        }
      },
      immediate: true
    },
    outputActive: {
      handler(val){
        if(val===1){
          this.$nextTick(() => {
            this.output = this.info.output.oneYear
            this.outputEchart()
          })
        }else{
          this.$nextTick(() => {
            this.output = this.info.output.fiveYear
            this.outputEchart()
          })
        }
      }
    },
    sellActive: {
      handler(val){
        if(val===1){
          this.$nextTick(() => {
            this.sell = this.info.sell.oneYear
            this.sellEchart()
          })
        }else{
          this.$nextTick(() => {
            this.sell = this.info.sell.fiveYear
            this.sellEchart()
          })
        }
      }
    },
    buyActive: {
      handler(val){
        if(val===1){
          this.$nextTick(() => {
            this.buy = this.info.buy.oneYear
            this.buyEchart()
          })
        }else{
          this.$nextTick(() => {
            this.buy = this.info.buy.fiveYear
            this.buyEchart()
          })
        }
      }
    }
  },
  methods: {
    getData(name){
      let params = {fileName: name}
      axios.post(this.$baseUrl+'/api/web/file/data/query',params).then(res => {
        if(res.data.code === 200){
          const jsonData = res.data.data
          this.info = jsonData.sell
          this.distanceData = this.info.express.distance
          this.output = this.info.output.oneYear
          this.sell = this.info.sell.oneYear
          this.buy = this.info.buy.oneYear
          this.area = this.info.area
          this.table = this.info.express.table
          this.$nextTick(() => {
            this.outputEchart()
            this.sellEchart()
            this.buyEchart()
            this.areaEchart()
            this.echartsDistance()
          })
        }
      })
    },
    fetchData(path) {
      axios.get(path+'?t=' + Date.now()).then(res => {
        const jsonData = res.data
        this.info = jsonData.sell
        this.distanceData = this.info.express.distance
        this.output = this.info.output.oneYear
        this.sell = this.info.sell.oneYear
        this.buy = this.info.buy.oneYear
        this.area = this.info.area
        this.table = this.info.express.table
        this.$nextTick(() => {
          this.outputEchart()
          this.sellEchart()
          this.buyEchart()
          this.areaEchart()
          this.echartsDistance()
        })
      })
    },
    outputEchart(){
      var chart = echarts.init(document.getElementById('output'));
      let dataX = this.output.map(it => {
        return it.date
      })
      let dataY = this.output.map(it => {
        return it.value
      })
      // 清空图表
      chart.clear();
      var option = {
        grid: {
          left: 0,   // 左侧距离
          right: 121,  // 右侧距离
          top: 30,   // 可选：顶部距离
          bottom: 0, // 可选：底部距离
          containLabel: true // 确保标签不被裁剪
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            color: '#fff', 
            fontSize: 36,
          },
          formatter: '{b}：{c}万元'
        },
        xAxis: {
          type: 'category',
          data: dataX,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#2A54A2', // 设置 x 轴线的颜色
              width: 3,
            }
          },
          boundaryGap: false,
          axisLabel: {
            color: '#fff', // 文字颜色
            fontSize: 28,   // 字体大小
            margin: 24
          }
        },
        yAxis: {
          type: 'value',
          axisLine: { 
            lineStyle: {
              color: '#2A54A2',
              width: 3,
            }
          },
          splitLine: { 
            lineStyle: {
              color: '#2A54A2',
              type: 'dashed',
              width: 2,
            }
          },
          axisTick: { show: false },
          axisLabel: {
            color: '#fff', // 文字颜色
            fontSize: 30,   // 字体大小
            margin: 42,
            formatter: '{value}万元'
          },
        },
        series: [
          {
            data: dataY,
            type: 'line',
            areaStyle: {
              color: '#2A54A2'
            },
            lineStyle: {
              color: '#0CFBFF',
              width: 3
            },
            label: {
              show: true,
              position: 'top',
              // formatter: '{c}万元',
              color: 'white',
              fontSize: 30, 
            },
            smooth: true
          }
        ]
      };
      chart.setOption(option)
    },
    sellEchart(){
      var chart = echarts.init(document.getElementById('sell'));
      let dataX = this.sell.map(it => {
        return it.date
      })
      let dataY = this.sell.map(it => {
        return it.value
      })
      let dataY2 = this.sell.map(it => {
        return it.price
      })
      // 清空图表
      chart.clear();
      var option = {
        grid: {
          left: 0,   // 左侧距离
          right: 121,  // 右侧距离
          top: 30,   // 可选：顶部距离
          bottom: 0, // 可选：底部距离
          containLabel: true // 确保标签不被裁剪
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            color: '#fff', 
            fontSize: 36,
          },
          // formatter: '{b}：{c}万元'
        },
        xAxis: {
          type: 'category',
          data: dataX,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#2A54A2', // 设置 x 轴线的颜色
              width: 3,
            }
          },
          boundaryGap: true,
          axisLabel: {
            color: '#fff', // 文字颜色
            fontSize: 28,   // 字体大小
            margin: 24
          }
        },
        yAxis: [{
          type: 'value',
          name: '外销（吨）',
          axisLine: { 
            lineStyle: {
              color: '#2A54A2',
              width: 3,
            }
          },
          splitLine: { 
            lineStyle: {
              color: '#2A54A2',
              type: 'dashed',
              width: 2,
            }
          },
          axisTick: { show: false },
          axisLabel: {
            color: '#00bfff', // 文字颜色
            fontSize: 30,   // 字体大小
            margin: 42,
            formatter: '{value}吨'
          },
        },{
          type: 'value',
          name: '收入（万元）',
          axisLine: { 
            lineStyle: {
              color: '#2A54A2',
              width: 3,
            }
          },
          splitLine: { 
            lineStyle: {
              color: '#2A54A2',
              type: 'dashed',
              width: 2,
            }
          },
          axisTick: { show: false },
          axisLabel: {
            color: '#ffeb3b', // 文字颜色
            fontSize: 30,   // 字体大小
            margin: 42,
            formatter: '{value}万元'
          },
        }],
        series: [
          {
            name: '外销（吨）',
            data: dataY,
            type: 'bar',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00bfff' },
                { offset: 1, color: '#0066cc' }
              ])
            },
            label: {
              show: true,
              position: 'top',
              // formatter: '{c}吨',
              color: 'white',
              fontSize: 30, 
            },
            yAxisIndex: 0
          },
          {
            name: '收入（万元）',
            data: dataY2,
            type: 'bar',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#ffeb3b' },
                { offset: 1, color: '#ffcc00' }
              ])
            },
            label: {
              show: true,
              position: 'top',
              // formatter: '{c}万元',
              color: 'white',
              fontSize: 30, 
            },
            yAxisIndex: 1
          }
        ]
      };
      chart.setOption(option)
    },
    buyEchart(){
      var chart = echarts.init(document.getElementById('buy'));
      let dataX = this.buy.map(it => {
        return it.date
      })
      let dataY = this.buy.map(it => {
        return it.value
      })
      let dataY2 = this.buy.map(it => {
        return it.price
      })
      // 清空图表
      chart.clear();
      var option = {
        grid: {
          left: 0,   // 左侧距离
          right: 121,  // 右侧距离
          top: 30,   // 可选：顶部距离
          bottom: 0, // 可选：底部距离
          containLabel: true // 确保标签不被裁剪
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            color: '#fff', 
            fontSize: 36,
          },
          // formatter: '{b}：{c}万元'
        },
        xAxis: {
          type: 'category',
          data: dataX,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#2A54A2', // 设置 x 轴线的颜色
              width: 3,
            }
          },
          boundaryGap: true,
          axisLabel: {
            color: '#fff', // 文字颜色
            fontSize: 28,   // 字体大小
            margin: 24
          }
        },
        yAxis: [{
          type: 'value',
          name: '外销（吨）',
          axisLine: { 
            lineStyle: {
              color: '#2A54A2',
              width: 3,
            }
          },
          splitLine: { 
            lineStyle: {
              color: '#2A54A2',
              type: 'dashed',
              width: 2,
            }
          },
          axisTick: { show: false },
          axisLabel: {
            color: '#00bfff', // 文字颜色
            fontSize: 30,   // 字体大小
            margin: 42,
            formatter: '{value}吨'
          },
        },{
          type: 'value',
          name: '收入（万元）',
          axisLine: { 
            lineStyle: {
              color: '#2A54A2',
              width: 3,
            }
          },
          splitLine: { 
            lineStyle: {
              color: '#2A54A2',
              type: 'dashed',
              width: 2,
            }
          },
          axisTick: { show: false },
          axisLabel: {
            color: '#ffeb3b', // 文字颜色
            fontSize: 30,   // 字体大小
            margin: 42,
            formatter: '{value}万元'
          },
        }],
        series: [
          {
            name: '外销（吨）',
            data: dataY,
            type: 'bar',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00bfff' },
                { offset: 1, color: '#0066cc' }
              ])
            },
            label: {
              show: true,
              position: 'top',
              // formatter: '{c}吨',
              color: 'white',
              fontSize: 30, 
            },
            yAxisIndex: 0
          },
          {
            name: '收入（万元）',
            data: dataY2,
            type: 'bar',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#ffeb3b' },
                { offset: 1, color: '#ffcc00' }
              ])
            },
            label: {
              show: true,
              position: 'top',
              // formatter: '{c}万元',
              color: 'white',
              fontSize: 30, 
            },
            yAxisIndex: 1
          }
        ]
      };
      chart.setOption(option)
    },
    areaEchart(){
      var chart = echarts.init(document.getElementById('area'));
      let dataX= this.area.map(it => {
        return it.name
      })
      let dataY = this.area.map(it => {
        return it.value
      })
      console.log(dataX)
      // 清空图表
      chart.clear();
      var option = {
        grid: {
          left: 0,   // 左侧距离
          right: 121,  // 右侧距离
          top: 30,   // 可选：顶部距离
          bottom: 0, // 可选：底部距离
          containLabel: true // 确保标签不被裁剪
        },
        xAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#2A54A2', // 设置 x 轴线的颜色
              width: 3,
            }
          },
          splitLine: {
            show: false
          },
          boundaryGap: false,
          axisLabel: {
            color: '#fff', // 文字颜色
            fontSize: 28,   // 字体大小
            margin: 24
          }
        },
        yAxis: {
          type: 'category',
          data: dataX,
          axisLine: {
            lineStyle: {
              color: '#2A54A2', // 设置 x 轴线的颜色
              width: 3,
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            color: '#fff', // 文字颜色
            fontSize: 30,   // 字体大小
            margin: 42,
          },
        },
        series: [
          {
            data: dataY,
            name: '外销（吨）',
            type: 'bar',
            label: {
              show: true,
              position: 'right',
              formatter: '{c}吨',
              color: '#fff',
              fontSize: 30
            },
            itemStyle: {
              color: function(params) {
                const colors = ['#00bfff', '#4CAF50', '#FF9800', '#2196F3', '#4CAF50', '#FFC107', '#9C27B0', '#00BCD4', '#8BC34A', '#FF5722', '#FFEB3B'];
                return colors[params.dataIndex % colors.length];
              }
            }
          }
        ]
      };
      chart.setOption(option)
    },
    // 签收距离
    echartsDistance(){
        var that = this
        // 散点图数据
        this.distanceData.from.value = this.distanceData.from.value.split(",")
        this.distanceData.to.forEach(it => {it.value = it.value.split(",")})
        var data =  [...this.distanceData.to,this.distanceData.from]
        var LineData = []
        this.distanceData.to.forEach(it => {
            LineData.push({
                fromName: this.distanceData.from.name,
                toName: it.name,
                coords: [this.distanceData.from.value, it.value],
                value: it.value,
                number: it.number
            })
        })

        var map = echarts.init(document.getElementById('sichuanMap'));
        let option = {
            grid: {
                left: 0,   // 左侧距离
                right: 0,  // 右侧距离
                top: 0,   // 可选：顶部距离
                bottom: 0, // 可选：底部距离
            },
            //地图
            geo: {
                type: 'map',
                map: 'china',
                width: '100%',
                height: '100%',
                top: 0,
                roam: true,
                label: {
                    normal: {
                        show: true,
                        color: '#ffffff',
                        fontSize: 36
                    },
                    emphasis: {
                        show: true,
                        textStyle: {
                            color: '#ffffff',
                            fontSize: 36
                        },
                    },
                },
                itemStyle: {
                    normal: {
                        areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                            {offset: 0, color: '#387FE9'},
                            {offset: 1, color: '#225FBA'}
                        ]),
                        borderWidth: 3,
                        borderColor: '#42AAFF',
                    },
                    emphasis: {
                        areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                            {offset: 0, color: '#F9B841'},
                            {offset: 1, color: '#FF6524'}
                        ]),
                        borderWidth: 3,
                        borderColor: '#FFD942',
                    },
                },
                // ========== 关键：使用 regions 高亮特定区域 ==========
                regions: (function() {
                    return [{
                      name: '四川',
                      itemStyle: {
                        areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                            {offset: 0, color: '#F9B841'},
                            {offset: 1, color: '#FF6524'}
                        ]),
                        borderWidth: 3,
                        borderColor: '#FFD942',
                      }
                    }];
                })()
                // ===================================================
            },
            series: [
                // 区域散点图
                {
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    zlevel: 2,
                    symbolSize: 20,
                    rippleEffect: { //坐标点动画
                        period: 3,
                        scale: 5,
                        brushType: 'fill'
                    },
                    itemStyle: { //坐标点颜色
                        normal: {
                            show: true,
                            color: '#31FFFF',
                            shadowBlur: 20,
                            shadowColor: '#fff'
                        },
                        emphasis: {
                            areaColor: '#f00'
                        }
                    },
                    label: {
                        show: true,
                        position: 'top',
                        color: '#fff',
                        fontSize: 36,
                        fontWeight: 'bold',
                        formatter: function (params) {
                          return params.data.number?params.data.number:params.data.number===0?0:params.name;
                        }
                    },
                    data: data
                },
                //飞线图
                {
                    type: 'lines',
                    zlevel: 2,
                    effect: {
                        show: true,
                        //飞机的速度  这里是s单位
                        period: 6,
                        trailLength: 0,
                        symbol: 'circle',//这是圆点替换了飞机
                        // 飞机大小
                        symbolSize: 20,
                        color:'#31FFFF',
                    },
                    lineStyle: {
                        normal: {
                            color:'#fff',
                            type:'solid', // 虚线
                            // 线条宽度
                            width: 3,
                            opacity: 1,
                            curveness: 0.2, // 弯曲度
                        },
                        emphasis: {
                            color: '#FF9600' //飞线悬浮颜色
                        }
                    },
                    label: {
                        normal: {
                            show: false,
                            position: 'middle',
                            formatter: '{b}'
                        }
                    },
                    data: LineData
                }
            
            ],
        };
        // 设置配置项
        map.setOption(option);
    },
  },
};
</script>
<style lang="less" scoped>
@import '@/styles/ganzi';

</style>